import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RouteParams } from '@app/shared/abstract/route-params';
import { RemediationAction, RemediationListResponse } from './payment-remediation.model';

/**
 * TVG-176: talks to the live payment remediation endpoints. The list runs its
 * criteria against current data on every request, so it is never cached.
 */
@Injectable({ providedIn: 'root' })
export class PaymentRemediationService {
  private readonly apiUrl = environment.apiUrl;
  private readonly basePath = '/api/payment-remediation';

  constructor(private readonly http: HttpClient) {}

  list(routeParams: RouteParams): Observable<RemediationListResponse> {
    return this.http.get<RemediationListResponse>(`${this.apiUrl}${this.basePath}${routeParams.toServiceQuery()}`);
  }

  fix(eventId: number): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}${this.basePath}/${eventId}/fix`, {});
  }

  bulkFix(eventIds: number[]): Observable<{ message: string; fixed: number[]; skipped: number[] }> {
    return this.http.post<{ message: string; fixed: number[]; skipped: number[] }>(
      `${this.apiUrl}${this.basePath}/bulk-fix`,
      { event_ids: eventIds },
    );
  }

  approveOverride(eventId: number): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}${this.basePath}/${eventId}/approve-override`, {});
  }

  reassign(eventId: number, ghostPaymentId: number, targetSyncTarget: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}${this.basePath}/${eventId}/reassign`, {
      ghost_payment_id: ghostPaymentId,
      target_sync_target: targetSyncTarget,
    });
  }

  /** Whether a case offers the given action (so the row action shows for that strand only). */
  static offers(caseActions: RemediationAction[], action: RemediationAction): boolean {
    return caseActions.includes(action);
  }
}
